module.exports = __webpack_public_path__ + "static/media/input.524fce7c.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/input.md
// module id = 383
// module chunks = 0